/* Inventory banner slider (sections/inventory-banner.liquid).
   Scroll-snap track; rotates every data-interval seconds, pauses on hover,
   focus, an off-screen banner, a hidden tab, or the pause button. Videos play
   only on the visible slide. */
(function () {
  function init(root) {
    if (root.dataset.ibReady) return;
    root.dataset.ibReady = '1';
    var track = root.querySelector('[data-ib-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ib-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ib-dot]'));
    var pauseBtn = root.querySelector('[data-ib-pause]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = Math.max(3, Number(root.dataset.interval) || 7) * 1000;
    var index = 0;
    var timer = null;
    var paused = reduce;
    var hovering = false;
    var visible = true;

    function current() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: index * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      index = current();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (el) { if (i === index) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
        var v = s.querySelector('video');
        if (v) {
          if (i === index && visible) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        }
      });
    }
    function schedule() {
      clearInterval(timer);
      if (paused || hovering || !visible || slides.length < 2 || document.hidden) return;
      timer = setInterval(function () { go(index + 1); }, interval);
    }

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(sync, 80);
    }, { passive: true });

    var prev = root.querySelector('[data-ib-prev]');
    var next = root.querySelector('[data-ib-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); schedule(); });
    if (next) next.addEventListener('click', function () { go(index + 1); schedule(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.ibDot)); schedule(); }); });
    if (pauseBtn) {
      if (paused) pauseBtn.setAttribute('aria-pressed', 'true');
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slides' : 'Pause slides');
        schedule();
      });
    }
    root.addEventListener('mouseenter', function () { hovering = true; schedule(); });
    root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    root.addEventListener('focusin', function () { hovering = true; schedule(); });
    root.addEventListener('focusout', function () { hovering = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);

    root.querySelectorAll('[data-ib-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        btn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
        // Keep a video with sound on screen.
        paused = !v.muted || paused;
        if (pauseBtn) pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        schedule();
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        sync();
        schedule();
      }, { threshold: 0.25 }).observe(root);
    }
    window.addEventListener('resize', function () { track.scrollLeft = index * track.clientWidth; });

    sync();
    schedule();
  }

  function boot() { document.querySelectorAll('[data-inventory-banner]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
